import CrmUtils from '../../services/crm-utils/CrmUtils';

export default async function GlobalOrganizationsProjects() {
    try {
        const response = await CrmUtils.getOrganizationProjects();
        if (response.data) {
            return response.data;
        }
        return [];
    } catch (error) {
        console.error('Error fetching organization projects:', error);
        return [];
    }
}
